import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { billingApi } from '../services/api';

const PlanDowngradeDialog = ({ plan, onClose, onScheduled }) => {
  const dialog = useRef(null);
  const cancel = useRef(null);
  const submitting = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const focus = document.activeElement;
    const root = document.getElementById('root');
    const inert = root?.inert;
    const overflow = document.body.style.overflow;
    if (root) root.inert = true;
    document.body.style.overflow = 'hidden';
    cancel.current.focus();
    return () => {
      if (root) root.inert = inert;
      document.body.style.overflow = overflow;
      focus?.focus();
    };
  }, []);
  const submit = async () => {
    if (submitting.current) return;
    submitting.current = true;
    setBusy(true);
    setError('');
    try {
      const result = await billingApi.changePlan(plan.id);
      if (result.status !== 'scheduled') throw new Error('The downgrade was not confirmed. Please retry.');
      onScheduled(result);
    } catch (err) {
      setError(err.message || 'Unable to schedule your downgrade.');
    } finally {
      submitting.current = false;
      setBusy(false);
    }
  };
  return createPortal(<div className="modal-backdrop" role="presentation">
    <section ref={dialog} className="confirmation-modal" role="dialog" aria-modal="true"
      aria-labelledby="downgrade-title" aria-describedby="downgrade-policy" aria-busy={busy}
      onKeyDown={event => {
        if (event.key === 'Escape' && !submitting.current) onClose();
        if (event.key === 'Tab') {
          const controls = [...dialog.current.querySelectorAll('button:not(:disabled)')];
          const first = controls[0], last = controls[controls.length - 1];
          if (!controls.length) event.preventDefault();
          else if (event.shiftKey && event.target === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && event.target === last) { event.preventDefault(); first.focus(); }
        }
      }}>
      <h2 id="downgrade-title">Downgrade to {plan.label}?</h2>
      <p id="downgrade-policy">Your current access stays unchanged until the next 1st (America/New_York). No refund is issued.</p>
      {plan.id === 'tier_0'
        ? <p>Your paid subscription will end then. Your account stays open with Free Tier access, or your previous Client access if eligible.</p>
        : <p>Your subscription will renew at the full monthly price of {plan.label} on that date.</p>}
      {error && <div className="error-box" role="alert">{error}</div>}
      <div className="confirmation-actions">
        <button ref={cancel} type="button" className="ghost-button" disabled={busy} onClick={onClose}>Keep current plan</button>
        <button type="button" className="primary-button" disabled={busy} onClick={submit}>{busy ? 'Scheduling...' : 'Confirm downgrade'}</button>
      </div>
    </section>
  </div>, document.body);
};

export default PlanDowngradeDialog;
